export default __webpack_public_path__ + "static/media/phone2frame.1e2e1648.svg";